/**
 * L'adresse de la console Artosera, que la régie propose en lien explicite
 * après l'acceptation d'une invitation d'associé (ARTO-58) : un associé n'a
 * aucune galerie, la seule page qui l'attend est la vue d'aigle de la console.
 *
 * L'API donne d'abord la sienne (`consoleUrl` dans la réponse d'acceptation,
 * variable `CONSOLE_URL`). À défaut, ordre de résolution, sans jamais inventer
 * de destination :
 *   1. `VITE_CONSOLE_URL`, quand l'environnement la pose (adresse complète,
 *      sans chemin : `https://console.artosera.com`) ;
 *   2. sinon, l'adresse sœur de la régie quand elle s'appelle `app.<domaine>` :
 *      `console.<domaine>` (production, démo) ;
 *   3. sinon `null` : la page dit alors à l'associé de se connecter à la
 *      console, sans lien.
 *
 * La session ne passe pas d'un hôte à l'autre (le cookie est posé par hôte) :
 * l'associé qui arrive sur la console s'y reconnecte. C'est voulu — la console
 * est un autre site, avec sa propre session.
 */
export function urlConsole(
  adresse: Pick<Location, 'protocol' | 'hostname'> = window.location,
  configuree: string | undefined = import.meta.env['VITE_CONSOLE_URL'],
): string | null {
  const voulue = configuree?.trim();
  if (voulue) return voulue.replace(/\/+$/, '');
  const { protocol, hostname } = adresse;
  if (hostname.startsWith('app.')) return `${protocol}//console.${hostname.slice('app.'.length)}`;
  return null;
}

/**
 * La page d'accueil d'un associé dans la console : l'adresse que l'API a donnée
 * à l'acceptation, sinon celle que la régie déduit, sinon `null`.
 */
export function urlVueDAigle(donneeParLApi?: string | null): string | null {
  const donnee = donneeParLApi?.trim();
  const adresse = donnee ? donnee.replace(/\/+$/, '') : urlConsole();
  return adresse === null ? null : `${adresse}/vue-d-aigle`;
}
